import placeholder from '../../assets/staticFiles/css/img/b64_img-placeholder.jpg.js';
import delivery from '../../assets/staticFiles/css/img/b64_img-delivery.png.js';
import webForm from '../../assets/staticFiles/css/img/b64_img-web_form.png.js';
import shoppingBag from '../../assets/staticFiles/css/img/b64_img-shopping_bag.png.js';
import loyality from '../../assets/staticFiles/css/img/b64_img-loyality.png.js';
import contact from '../../assets/staticFiles/css/img/b64_img-contact.png.js';
import top from '../../assets/staticFiles/css/img/b64_img-top.png.js';
import SizeTableM from '../../assets/staticFiles/css/img/b64_img-SizeTableM.jpg.js';
import SizeTableW from '../../assets/staticFiles/css/img/b64_img-SizeTableW.jpg.js';
import BodyContourM from '../../assets/staticFiles/css/img/b64_img-BodyContourM.png.js';
import BodyContourW from '../../assets/staticFiles/css/img/b64_img-BodyContourW.png.js';
import LogisticPartner from '../../assets/staticFiles/css/img/b64_img-LogisticPartner.png.js';
import PaymentOperator from '../../assets/staticFiles/css/img/b64_img-PaymentOperator.png.js';
import {getTranslationLang} from '../../assets/creator/translations';
import b64EncodeUnicode from '../jsonGeneratingFunctions/helpers/base64Encoder.js';
import bannerSettingsTemplate from '../bannerSettingsTemplate.js'; 
import bannerSettings from '../bannerSettings.js';

const getTranslationLangWithoutNull = (translationText, lang = "pl") => getTranslationLang(translationText, lang) || "";

function pushBannerData(banners, bannerName, checkingCondition, dataArray, bannersWithStaticFiles) {
    bannersWithStaticFiles.push(bannerName);
    if (checkingCondition) {
        let Data = "";
        const JSON = "";
        const ITemplate = b64EncodeUnicode(bannerSettingsTemplate);
        const Settings = bannerSettings;
        const I = [];
        const langs = ["pl", "en", "de", "fr"];
        const langsId = [1, 2, 3, 5];
        for (let i=0; i<=3; i++) {
            for (const bannerData of dataArray) {
                Data = bannerData.data;
                I.push({
                    "@": {
                        "FileName": bannerData.fileName,
                        "Mime": bannerData.mime,
                        "No": bannerData.no,
                        "Url": bannerData.url,
                        "Title": bannerData.title,
                        "Alt": getTranslationLangWithoutNull(bannerData.alt),
                        "Blank": bannerData.blank,
                        "Heading": getTranslationLangWithoutNull(bannerData.heading, langs[i]),
                        "Text": getTranslationLangWithoutNull(bannerData.text, langs[i]),
                        "LngId": langsId[i]
                    }, Data, JSON
                })
            }
        }
        if (bannerName === "top") {
            banners.push({
                "@": {
                    "Name": bannerName,
                    "Notes": '',
                    "Type": "1"
                }, I, ITemplate, Settings
            });
        } else {
            banners.push({
                "@": {
                    "Name": bannerName,
                    "Notes": '',
                    "Type": "1"
                }, I
            });
        }
    }
}

//TODO, NOTE: this function doesn't check for element duplicates, add this check if necessary (possible UNIQUE KEY CONSTRAINT violation when adding xml)
function pushBanner(banners, bannerName) {
    let duplicateHomePage = false;
    const I = [];
    const ITemplate = b64EncodeUnicode(bannerSettingsTemplate);
    
    for (const key in banners) {   
        for (const key2 in banners[key]) {
            if (banners[key][key2].Name === "homepage") {
                duplicateHomePage=true
                break; 
            }
        }
    }

    const bannersWithStaticFiles = [];

    pushBannerData(banners, "homepage-small", bannerName === "homepage-small", [{
        data: delivery,
        fileName: "delivery.png",
        mime: "image/png",
        no: "0",
        url: "",
        title: "",
        alt: "",
        blank: "0",
        heading: "HomepageSmallBannerDeliveryHeading",
        text: "HomepageSmallBannerDeliveryText",
    }, {
        data: webForm,
        fileName: "web_form.png",
        mime: "image/png",
        no: "1",
        url: "",
        title: "",
        alt: "",
        blank: "0",
        heading: "HomepageSmallBannerFormHeading",
        text: "HomepageSmallBannerFormText",
    }, {
        data: shoppingBag,
        fileName: "shopping_bag.png",
        mime: "image/png",
        no: "2",
        url: "",
        title: "",
        alt: "",
        blank: "0",
        heading: "HomepageSmallBannerShoppingHeading",
        text: "HomepageSmallBannerShoppingText",
    }, {
        data: loyality,
        fileName: "loyality.png",
        mime: "image/png",
        no: "3",
        url: "",
        title: "",
        alt: "",
        blank: "0",
        heading: "HomepageSmallBannerLoyalityHeading",
        text: "HomepageSmallBannerLoyalityText",
    }, {
        data: contact,
        fileName: "contact.png",
        mime: "image/png",
        no: "4",
        url: "",
        title: "",
        alt: "",
        blank: "0",
        heading: "HomepageSmallBannerContactHeading",
        text: "HomepageSmallBannerContactText",
    }], bannersWithStaticFiles);
    pushBannerData(banners, "widgetBanner", bannerName === "widgetBanner", [{
        data: placeholder,
        fileName: "placeholder.jpg",
        mime: "image/jpg",
        no: "0",
        url: "",
        title: "Widget1_Title",
        alt: "205x205",
        blank: "0",
        heading: "Widget1_Heading",
        text: "Widget1_Text",
    }], bannersWithStaticFiles);
    pushBannerData(banners, "widgetBanner2", bannerName === "widgetBanner2", [{
        data: placeholder,
        fileName: "placeholder.jpg",
        mime: "image/jpg",
        no: "0",
        url: "",
        title: "",
        alt: "100x100",
        blank: "0",
        heading: "Widget2_Heading",
        text: "Widget2_Text",
    }], bannersWithStaticFiles);
    pushBannerData(banners, "SizeTable", bannerName === "SizeTable", [{
        data: SizeTableM,
        fileName: "SizeTableM.jpg",
        mime: "image/jpg",
        no: "1",
        url: "",
        title: "table",
        alt: "",
        blank: "0",
        heading: "Sizetable_HeadingM",
        text: "Sizetable_Text",
    }, {
        data: BodyContourM,
        fileName: "BodyContourM.jpg",
        mime: "image/jpg",
        no: "2",
        url: "",
        title: "contour",
        alt: "",
        blank: "0",
        heading: "BodyContour_Heading",
        text: "BodyContour_Text",
    }, {
        data: SizeTableW,
        fileName: "SizeTableW.jpg",
        mime: "image/jpg",
        no: "3",
        url: "",
        title: "table",
        alt: "",
        blank: "0",
        heading: "Sizetable_HeadingW",
        text: "Sizetable_Text",
    }, {
        data: BodyContourW,
        fileName: "BodyContourW.jpg",
        mime: "image/jpg",
        no: "4",
        url: "",
        title: "contour",
        alt: "",
        blank: "0",
        heading: "BodyContour_Heading",
        text: "BodyContour_Text",
    }], bannersWithStaticFiles);
    pushBannerData(banners, "LogisticsPartners", bannerName === "LogisticsPartners", [{
        data: LogisticPartner,
        fileName: "LogisticPartner.png",
        mime: "image/png",
        no: "0",
        url: "",
        title: "",
        alt: "",
        blank: "0",
        heading: "",
        text: "",
    }], bannersWithStaticFiles);
    pushBannerData(banners, "PaymentOperators", bannerName === "PaymentOperators", [{
        data: PaymentOperator,
        fileName: "PaymentOperator.png",
        mime: "image/png",
        no: "0",
        url: "",
        title: "",
        alt: "",
        blank: "0",
        heading: "",
        text: "",
    }], bannersWithStaticFiles);
    pushBannerData(banners, "banner_popup1", bannerName === "banner_popup1", [{
        data: placeholder,
        fileName: "img-placeholder.jpg",
        mime: "image/jpg",
        no: "0",
        url: "",
        title: "",
        alt: "",
        blank: "0",
        heading: "PopupBannerHeading",
        text: "PopupBannerText",
    }], bannersWithStaticFiles);
    pushBannerData(banners, "banner_popup2", bannerName === "banner_popup2", [{
        data: placeholder,
        fileName: "img-placeholder.jpg",
        mime: "image/jpg",
        no: "0",
        url: "",
        title: "",
        alt: "",
        blank: "0",
        heading: "PopupBannerHeading",
        text: "PopupBannerText",
    }], bannersWithStaticFiles);
    pushBannerData(banners, "top", bannerName === "top", [{
        data: top,
        fileName: "top.png",
        mime: "image/png",
        no: "0",
        url: "",
        title: "",
        alt: "",
        blank: "0",
        heading: "",
        text: "TopBanner_Text",
    }], bannersWithStaticFiles);
    
    if (bannerName.includes("promotionalBanner-2")) {
        banners.push({
            "@": {
                "Name": bannerName,
                "Notes": '',
            }, I, ITemplate
        });
    }

    if (!bannersWithStaticFiles.some(bnrName => bnrName === bannerName)) {
        const isNotToPush = banners.some((element) => element['@'].Name === bannerName);
        if (!isNotToPush) {
            banners.push({
                "@": {
                    "Name": bannerName, 
                    "Notes": '',
                    "Type": "1",
                }
            });
        }
    }
}

//gets banner elements from creator sites (banners are available only for main page at the moment of writing)
function addBannersFromCreatorSite(banners, site = null, containerName = null) {
    let promotionalBannerIndex = 1;
    let list = this.state[containerName];
    if (site) {
        list = this.state[site.listName];
    }
    list.forEach((element) => {
        if (element.type === 'mainBanner') {
            pushBanner(banners, element.name);
        }
        if (element.relatedBanner) {
            pushBanner(banners, element.relatedBanner);
        }
        if (element.relatedBanner2) {
            pushBanner(banners, element.relatedBanner2);
        }
        if (element.type === 'promotionalBanner') {
            pushBanner(banners, element.id + '-' + promotionalBannerIndex++);
        }
    });
}
//gets banner elements from static elements (to add banner to static element add field "relatedBanner" to the static element definition object)
function addBannersFromStaticSite(banners, site) {
    const staticElement = site.name.split('.')[0];
    const siteObj = require(`../../assets/static-elements/${staticElement}`).default;
    if (siteObj[0].relatedBanner) {
        pushBanner(banners, siteObj[0].relatedBanner);
    }
}

//constructs object that contains banner definitions for XML
function getBanners() {
    const banners = [];
    const defSites = require('../../assets/defSites.json');
    defSites.forEach((site) => {
        if (!site.listName) {
            //no list name assumes that page is static element
            addBannersFromStaticSite(banners, site);
        }
        else {
            //listname assumes that page is created in creator
            addBannersFromCreatorSite.call(this, banners, site);
        }
    });
    addBannersFromCreatorSite.call(this, banners, null, "header");
    addBannersFromCreatorSite.call(this, banners, null, "footer");
    return { B: banners };
}

export default getBanners;